module.exports = __webpack_public_path__ + "static/media/parking.42f032cf.svg";